import cn from "@utils/cn";
import { Router } from "@utils";
import Icon from "@elements/Icon";

const CLASS_NAMES = cn(`
  flex
  items-center
  w-full
  gap-3
  px-6
  py-4
  border-t
  transition-colors

  text-(--navbar-foreground-color)
  border-t-[#66666633]

  hover:bg-black/20
`);

const LABEL_CLASS_NAMES = cn(`
  text-base
  font-medium
`);

export default function UserLogoutDrawerItem(props) {
  const {
    closeDrawer,
  } = props;

  const handleClick = () => {
    closeDrawer();
    Router.redirectToPath("/logout");
  };

  return (
    <button
      className={CLASS_NAMES}
      onClick={handleClick}
    >
      <Icon
        iconName="right-from-bracket"
        fixedWidth={true}
      />

      <span className={LABEL_CLASS_NAMES}>
        Log Out
      </span>
    </button>
  );
}
